export { SITE_URL, SITE_NAME, GOOGLE_MAPS_URL, siteUrl } from "./site";

/** Google Form enquiry / quotation (responses go to your sheet) */
export const ENQUIRY_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfjaAvxkx2hAlansEabrZOVZNDcSmHQ2XauLMOtP7GtPhMlDQ/viewform?usp=header";

/** BS Agro contact — call & WhatsApp */
export const PHONE_NUMBER = "7603809596";
export const PHONE_TEL = `tel:+91${PHONE_NUMBER}`;
export const WHATSAPP_NUMBER = `91${PHONE_NUMBER}`;
